import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("从模板创建")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("创建合同")
const _hoisted_5 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("详细")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 编辑合同 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 提交合同 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 导出审批表 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 删除合同 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("创建")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, reactive, unref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElButton, ElTag, ElMessage, ElMessageBox } from 'element-plus';
import { GbTables } from '@/components/GbTables';
import { GbDialog } from '@/components/GbDialog/Index';
import { CreateByTempForm } from './forms/Index';
import { useGbTable } from '@/hooks/useGbTable';
import { useCreateByTemp } from './hooks/useCreateByTemp';
import { useDictionary } from '@/store/dictionary.store';
import { GetContractListApi, delContract, CtSubmitApi, InsCtByTempApi, ExportCtAuditWordApi } from '../../apis/contract/contract.api';
import { ContractDelDto } from '../../apis/contract/contract.type';
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { CreateByTemplateDto } from '../../apis/contract/contract.dto';
import { saveAs } from 'file-saver';
import moment from 'moment';

/* GbTable 配置 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetContractListApi,
	delListApi: delContract,
	response: { data: 'data', total: 'total' },
});

const { getName } = useDictionary();
const { setSearchParams } = methods;
const { push } = useRouter();
const { query } = useRoute();

const showDialog = ref<boolean>(false);

const searchDto = reactive<any>({
	page_size: 10,
	current: 1,
	status: '',
});

const useCtct = useCreateByTemp();

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'status', label: '状态', align: 'center', columnWidth: '100' },
	{ field: 'no', label: '合同编号', columnWidth: '150' },
	{ field: 'name', label: '合同名称', columnWidth: '200' },
	{ field: 'counterpart_name', label: '相对方' },
	{ field: 'plan_a_name', label: '我方主体' },
	{ field: 'sign_day', label: '签订日期', columnWidth: '120' },
	{ field: 'contract_amount', label: '合同总价', columnWidth: '120', align: 'right' },
	{ field: 'next_node_name', label: '下一节点', columnWidth: '100', align: 'center' },
	{ field: 'next_emp_name', label: '处理人', columnWidth: '80', align: 'center' },
	{ field: 'created_time', label: '创建日期', columnWidth: '120', fixed: 'right' },
	{ field: 'action', width: '120px', label: '操作', fixed: 'right', align: 'center' },
]);

/* 操作按钮 */
const actions = {
	/* 创建合同 */
	create: () => {
		push('/contract/create');
	},

	/* 创建合同(模板) */
	createByTemp: () => {
		const cpfuncs = useCtct.methods;

		unref(useCtct.elFormRef)?.validate((isValid: boolean) => {
			if (!isValid) return;

			cpfuncs.setLoading(true);

			const formData: CreateByTemplateDto = cpfuncs.getFormData();

			/* 调用创建的接口 */
			InsCtByTempApi(formData)
				.then((res) => {
					if (!res.succeeded) {
						ElMessage.error(`从模板创建合同失败，可能的原因是：${res.errors}`);
					} else {
						ElMessageBox.confirm('操作成功，是否跳转到编辑页面？', '提示', { lockScroll: false, confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
							.then(() => {
								push(`/contract/modify?contractId=${res.data}`);
							})
							.catch(() => {
								showDialog.value = false;
								setSearchParams(searchDto);
							});
					}
				})
				.finally(() => {
					cpfuncs.setLoading(false);
				});
		});
	},

	/* 编辑 */
	modify: (rowId: string) => {
		push(`/contract/modify?contractId=${rowId}`);
	},

	/* 预览 */
	preview: (rowId: string) => {
		push(`/contract/detail?contractId=${rowId}`);
	},

	/* 删除数据 */
	delete: async (row: any) => {
		const delData: ContractDelDto = { id: row.id, revision: row.revision };
		await methods.deleteRows(delData);
	},
	exportWord: (row: any) => {
		ExportCtAuditWordApi(row.id)
			.then((res: any) => {
				const { status, data } = res;
				if (status != 200) ElMessage.error('导出失败，请联系管理员');
				else {
					const blob = new Blob([data]);
					const title = `合同/文件会签审批表.docx`;
					saveAs(blob, title);
				}
			})
			.catch((err) => {
				ElMessage.error(err);
			})
			.finally(() => {});
	},

	/* 提交合同 */
	submit: (row: any) => {
		ElMessageBox.confirm('是否提交选中的数据？', '提示', { lockScroll: false, confirmButtonText: '提交', cancelButtonText: '取消', type: 'warning' }).then(() => {
			tableObject.loading = true;

			CtSubmitApi(row.id, '', row.revision)
				.then((res) => {
					if (!res.succeeded) {
						ElMessage.error(`提交失败！可能的原因：${res.errors}`);
					} else {
						ElMessage.success('提交审核成功');
					}
				})
				.finally(() => {
					tableObject.loading = false;
					setSearchParams(searchDto);
				});
		});
	},
	reSet: () => {
		searchDto.page_size = 10;
		searchDto.current = 1;
		searchDto.status = '';
		searchDto.no = '';
		searchDto.name = '';
		setSearchParams(searchDto);
	},
};

const auth = {
	curd: (row: any) => {
		if (row.is_owner) {
			const disabled = ['1', '8'].indexOf(`${row.status}`) == -1 ? true : false;
			return disabled;
		} else {
			return true;
		}
	},
	export: (row: any) => {
		if (row.is_owner) {
			const disabled = ['1', '2'].indexOf(`${row.status}`) == -1 ? false : true;
			return disabled;
		} else {
			return true;
		}
	},
};

onMounted(() => {
	setSearchParams(searchDto);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(searchDto),
          size: "small",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: "合同编号"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(searchDto).no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchDto).no) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: "合同名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(searchDto).name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchDto).name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: "合同状态"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"100%"},
                  modelValue: _unref(searchDto).status,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchDto).status) = $event)),
                  placeholder: "合同状态",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(setSearchParams)(_unref(searchDto))))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部",
                      value: ""
                    }),
                    _createVNode(_component_el_option, {
                      label: "草稿",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "审批中",
                      value: "2"
                    }),
                    _createVNode(_component_el_option, {
                      label: "用印申请",
                      value: "3"
                    }),
                    _createVNode(_component_el_option, {
                      label: "用印确认",
                      value: "10"
                    }),
                    _createVNode(_component_el_option, {
                      label: "合同入档",
                      value: "9"
                    }),
                    _createVNode(_component_el_option, {
                      label: "履约中",
                      value: "4"
                    }),
                    _createVNode(_component_el_option, {
                      label: "归档",
                      value: "5"
                    }),
                    _createVNode(_component_el_option, {
                      label: "退回",
                      value: "8"
                    }),
                    _createVNode(_component_el_option, {
                      label: "终止",
                      value: "6"
                    }),
                    _createVNode(_component_el_option, {
                      label: "结束",
                      value: "7"
                    }),
                    _createVNode(_component_el_option, {
                      label: "作废",
                      value: "11"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Refresh",
                      onClick: actions.reSet
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      icon: "Search",
                      type: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(setSearchParams)(_unref(searchDto))))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "DocumentCopy",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showDialog.value = true))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ElButton), {
                      icon: "Plus",
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (actions.create()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"},
      disabled: _unref(tableObject).loading
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          status: _withCtx(({ row }) => [
            (row.status == 1)
              ? (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 0,
                  size: "small",
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getName)('contract_status', row.status)), 1)
                  ]),
                  _: 2
                }, 1024))
              : (row.status == 2 || row.status == 3)
                ? (_openBlock(), _createBlock(_unref(ElTag), {
                    key: 1,
                    size: "small",
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getName)('contract_status', row.status)), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (row.status == 8)
                  ? (_openBlock(), _createBlock(_unref(ElTag), {
                      key: 2,
                      size: "small",
                      type: "info"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getName)('contract_status', row.status)), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (row.status == 11)
                    ? (_openBlock(), _createBlock(_unref(ElTag), {
                        key: 3,
                        size: "small",
                        type: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getName)('contract_status', row.status)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(_unref(ElTag), {
                        key: 4,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getName)('contract_status', row.status)), 1)
                        ]),
                        _: 2
                      }, 1024))
          ]),
          contract_amount: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.contract_amount.toLocaleString('zh')), 1)
          ]),
          sign_day: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.sign_day).format('YYYY-MM-DD')), 1)
          ]),
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          action: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(ElButton), {
                icon: "Memo",
                type: "text",
                size: "small",
                onClick: ($event: any) => (actions.preview(row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_dropdown, {
                style: {"padding":"2px","margin-left":"12px"},
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            type: "text",
                            disabled: auth.curd(row),
                            link: "",
                            onClick: ($event: any) => (actions.modify(row.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            type: "text",
                            disabled: auth.curd(row),
                            link: "",
                            onClick: ($event: any) => (actions.submit(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            type: "text",
                            link: "",
                            disabled: auth.export(row),
                            onClick: ($event: any) => (actions.exportWord(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_dropdown_item, { divided: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            type: "danger",
                            disabled: auth.curd(row),
                            link: "",
                            onClick: ($event: any) => (actions.delete(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_More)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_unref(GbDialog), {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showDialog).value = $event)),
      title: "从模板创建合同",
      style: {"width":"640px"}
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(ElButton), {
          type: "primary",
          onClick: actions.createByTemp
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_unref(ElButton), {
          type: "info",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(CreateByTempForm), {
          onRegister: _unref(useCtct).register
        }, null, 8, ["onRegister"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})